var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.fullNameTitle,
            visible: _vm.dialogVisible,
            width: "700px",
            "before-close": _vm.closeDialog,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "attendanceKid",
              attrs: {
                "label-width": "120px",
                model: _vm.attendanceKid.attendanceArriveKids,
                "label-position": "top",
              },
            },
            [
              _c(
                "el-row",
                {
                  staticStyle: { "margin-top": "10px" },
                  attrs: { gutter: 20 },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c("div", { staticClass: "shift-card" }, [
                        _c("div", { staticClass: "shift-header" }, [
                          _c("strong", [_vm._v("Ghi chú chung")]),
                        ]),
                        _c("div", { staticClass: "shift-row" }, [
                          _c(
                            "div",
                            {
                              staticClass: "shift-col shift-note",
                              staticStyle: { width: "100%" },
                            },
                            [
                              _c("div", { staticClass: "shift-media-title" }, [
                                _vm._v("Nội dung ghi chú cho ngày điểm danh"),
                              ]),
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  rows: 4,
                                  placeholder: "Nhập nội dung ghi chú...",
                                },
                                model: {
                                  value:
                                    _vm.attendanceKid.attendanceArriveKids
                                      .arriveContent,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.attendanceKid.attendanceArriveKids,
                                      "arriveContent",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "attendanceKid.attendanceArriveKids.arriveContent",
                                },
                              }),
                              _vm.attendanceKid.attendanceArriveKids
                                .idCreated != null
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "shift-status",
                                      staticStyle: { "margin-top": "16px" },
                                    },
                                    [
                                      _vm.attendanceKid.attendanceArriveKids
                                        .createdDate !==
                                      _vm.attendanceKid.attendanceArriveKids
                                        .lastModifieDate
                                        ? _c("div", [
                                            _vm._v(
                                              "\n                    Điểm danh lần cuối: "
                                            ),
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.attendanceKid
                                                    .attendanceArriveKids
                                                    .lastModifieBy
                                                )
                                              ),
                                            ]),
                                            _c("br"),
                                            _vm.attendanceKid
                                              .attendanceArriveKids
                                              .lastModifieBy !== "Hệ thống"
                                              ? _c("span", [
                                                  _vm._v(
                                                    "Thời gian: " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatDateTime"
                                                        )(
                                                          _vm.attendanceKid
                                                            .attendanceArriveKids
                                                            .lastModifieDate
                                                        )
                                                      )
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ])
                                        : _c("div", [
                                            _vm._v(
                                              "\n                    Điểm danh: "
                                            ),
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.attendanceKid
                                                    .attendanceArriveKids
                                                    .createdBy
                                                )
                                              ),
                                            ]),
                                            _c("br"),
                                            _vm.attendanceKid
                                              .attendanceArriveKids
                                              .createdBy !== "Hệ thống"
                                              ? _c("span", [
                                                  _vm._v(
                                                    "Thời gian: " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatDateTime"
                                                        )(
                                                          _vm.attendanceKid
                                                            .attendanceArriveKids
                                                            .createdDate
                                                        )
                                                      )
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _c("el-divider"),
                    ],
                    1
                  ),
                  _vm.attendanceConfigResponse.morningAttendanceArrive
                    ? _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c("div", { staticClass: "shift-card" }, [
                            _c("div", { staticClass: "shift-header" }, [
                              _c("strong", [_vm._v("Buổi sáng")]),
                            ]),
                            _c(
                              "div",
                              { staticClass: "shift-row two-columns" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "shift-col shift-media" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "shift-media-title" },
                                      [_vm._v("Ảnh đến")]
                                    ),
                                    _c("image-uploader", {
                                      attrs: {
                                        preview:
                                          _vm.attendanceKid.attendanceArriveKids
                                            .arriveUrlPictureMorning,
                                        placeholder: "Tải ảnh đến",
                                        updateAttendance: true,
                                      },
                                      model: {
                                        value: _vm.morningArriveMultipartFile,
                                        callback: function ($$v) {
                                          _vm.morningArriveMultipartFile = $$v
                                        },
                                        expression:
                                          "morningArriveMultipartFile",
                                      },
                                    }),
                                    _c("div", { staticClass: "shift-time" }, [
                                      _vm._v("\n                  Giờ đến: "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("formatTime")(
                                              _vm.attendanceKid
                                                .attendanceArriveKids
                                                .timeArriveKidMorning
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "shift-col shift-media" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "shift-media-title" },
                                      [_vm._v("Ảnh về")]
                                    ),
                                    _c("image-uploader", {
                                      attrs: {
                                        preview:
                                          _vm.attendanceKid.attendanceLeaveKids
                                            .leaveUrlPictureMorning,
                                        placeholder: "Tải ảnh về",
                                        updateAttendance: true,
                                      },
                                      model: {
                                        value: _vm.morningLeaveMultipartFile,
                                        callback: function ($$v) {
                                          _vm.morningLeaveMultipartFile = $$v
                                        },
                                        expression: "morningLeaveMultipartFile",
                                      },
                                    }),
                                    _c("div", { staticClass: "shift-time" }, [
                                      _vm._v("\n                  Giờ về: "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("formatTime")(
                                              _vm.attendanceKid
                                                .attendanceLeaveKids
                                                .timeLeaveKidMorning
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]),
                          _c("el-divider"),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.attendanceConfigResponse.afternoonAttendanceArrive
                    ? _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c("div", { staticClass: "shift-card" }, [
                            _c("div", { staticClass: "shift-header" }, [
                              _c("strong", [_vm._v("Buổi chiều")]),
                            ]),
                            _c(
                              "div",
                              { staticClass: "shift-row two-columns" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "shift-col shift-media" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "shift-media-title" },
                                      [_vm._v("Ảnh đến")]
                                    ),
                                    _c("image-uploader", {
                                      attrs: {
                                        preview:
                                          _vm.attendanceKid.attendanceArriveKids
                                            .arriveUrlPictureAfternoon,
                                        placeholder: "Tải ảnh đến",
                                        updateAttendance: true,
                                      },
                                      model: {
                                        value: _vm.afternoonArriveMultipartFile,
                                        callback: function ($$v) {
                                          _vm.afternoonArriveMultipartFile = $$v
                                        },
                                        expression:
                                          "afternoonArriveMultipartFile",
                                      },
                                    }),
                                    _c("div", { staticClass: "shift-time" }, [
                                      _vm._v("\n                  Giờ đến: "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("formatTime")(
                                              _vm.attendanceKid
                                                .attendanceArriveKids
                                                .timeArriveKidAfternoon
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "shift-col shift-media" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "shift-media-title" },
                                      [_vm._v("Ảnh về")]
                                    ),
                                    _c("image-uploader", {
                                      attrs: {
                                        preview:
                                          _vm.attendanceKid.attendanceLeaveKids
                                            .leaveUrlPictureAfternoon,
                                        placeholder: "Tải ảnh về",
                                        updateAttendance: true,
                                      },
                                      model: {
                                        value: _vm.afternoonLeaveMultipartFile,
                                        callback: function ($$v) {
                                          _vm.afternoonLeaveMultipartFile = $$v
                                        },
                                        expression:
                                          "afternoonLeaveMultipartFile",
                                      },
                                    }),
                                    _c("div", { staticClass: "shift-time" }, [
                                      _vm._v("\n                  Giờ về: "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("formatTime")(
                                              _vm.attendanceKid
                                                .attendanceLeaveKids
                                                .timeLeaveKidAfternoon
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]),
                          _c("el-divider"),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.attendanceConfigResponse.eveningAttendanceArrive
                    ? _c("el-col", { attrs: { span: 24 } }, [
                        _c("div", { staticClass: "shift-card" }, [
                          _c("div", { staticClass: "shift-header" }, [
                            _c("strong", [_vm._v("Buổi tối")]),
                          ]),
                          _c("div", { staticClass: "shift-row two-columns" }, [
                            _c(
                              "div",
                              { staticClass: "shift-col shift-media" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "shift-media-title" },
                                  [_vm._v("Ảnh đến")]
                                ),
                                _c("image-uploader", {
                                  attrs: {
                                    preview:
                                      _vm.attendanceKid.attendanceArriveKids
                                        .arriveUrlPictureEvening,
                                    placeholder: "Tải ảnh đến",
                                    updateAttendance: true,
                                  },
                                  model: {
                                    value: _vm.eveningArriveMultipartFile,
                                    callback: function ($$v) {
                                      _vm.eveningArriveMultipartFile = $$v
                                    },
                                    expression: "eveningArriveMultipartFile",
                                  },
                                }),
                                _c("div", { staticClass: "shift-time" }, [
                                  _vm._v("\n                  Giờ đến: "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatTime")(
                                          _vm.attendanceKid.attendanceArriveKids
                                            .timeArriveKidEvening
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "shift-col shift-media" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "shift-media-title" },
                                  [_vm._v("Ảnh về")]
                                ),
                                _c("image-uploader", {
                                  attrs: {
                                    preview:
                                      _vm.attendanceKid.attendanceLeaveKids
                                        .leaveUrlPictureEvening,
                                    placeholder: "Tải ảnh về",
                                    updateAttendance: true,
                                  },
                                  model: {
                                    value: _vm.eveningLeaveMultipartFile,
                                    callback: function ($$v) {
                                      _vm.eveningLeaveMultipartFile = $$v
                                    },
                                    expression: "eveningLeaveMultipartFile",
                                  },
                                }),
                                _c("div", { staticClass: "shift-time" }, [
                                  _vm._v("\n                  Giờ về: "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatTime")(
                                          _vm.attendanceKid.attendanceLeaveKids
                                            .timeLeaveKidEvening
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                              ],
                              1
                            ),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "danger", size: "medium" },
                  on: { click: _vm.closeDialogByButton },
                },
                [
                  _c("i", { staticClass: "el-icon-circle-close" }),
                  _vm._v(" Đóng\n      "),
                ]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "success",
                    size: "medium",
                    loading: _vm.loadingButton,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm("attendanceKid")
                    },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-circle-check" }),
                  _vm._v(" Lưu\n      "),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }